$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});


$(document).on('change', '.choose-date', function () {
    var date = moment($(this).val(),'M/D/YYYY').format('D.M.YYYY');
    var times ='';
    var $this = $(this);
    $('input[name="appointmentTypeID"]').val($this.data('id'));

    $.ajax({
        method: "GET",
        url: "/api/availability/times",
        data: { id: $(this).data('id'),date: date}
    })
        .done(function( data ) {
            $('a[href="#info"]').show();
            $this.closest('.introductory-item__form').find('.select-time').addClass('is-show');
            var i=0;
            var {convertDateTimeToUSAFormat} = require('./helpers/dateTimeToUSAFormat.js');
            $.each(data, function () {
                if (i<1) {
                    $('input[name="datetime"]').val($(this)[0].time);
                    i++
                }
                times += '<option class="select-btn" data-time="'+$(this)[0].time+'" value="'+$(this)[0].time+'" >'+convertDateTimeToUSAFormat($(this)[0].time)+'</option>'
            });
            $this.closest('form').find('.select-time').html(times).show();
        });
});


$(function () {
    $('.choose-time').each(function () {
        $(this).hide();
    })
    $.datetimepicker.setLocale('en');
    $.datetimepicker.setDateFormatter({
        parseDate: function (date, format) {
            var d = moment(date, 'M/D/YYYY');
            return d.isValid() ? d.toDate() : false;
        },
        formatDate: function (date, format) {
            return moment(date).format('M/D/YYYY');
        },
    });
    $('.input-date').each(function () {
        var dates = $(this).data('dates');
        var avail = [];
        var i=0;
        if (dates !== undefined && dates.length > 0) {
            dates = dates.split(', ');

            dates.forEach(function (date) {
                if (date !== undefined) {
                    avail[i] = moment(date).format('M/D/YYYY')
                    i++
                }

            })
        }
        $(this).datetimepicker({
            timepicker: false,
            allowDates: avail,
            formatDate: 'M.D.YYYY',
            scrollMonth : false,
            scrollInput : false
        })
    })
});
